import $ from "jquery";

type HttpMethod = "GET" | "POST" | "DELETE";

// @ts-ignore
const ajaxurl = innosend_client.ajax;
// @ts-ignore
const nonce = innosend_client.nonce;

export function ajaxRequest<T>(method: HttpMethod, action: string, data: Record<string, any> = {}): Promise<T> {
	return new Promise((resolve, reject) => {
		const options: JQueryAjaxSettings = {
			url: ajaxurl,
			method: method,
			data: { action, nonce, ...data },
			dataType: "json"
		};

		$.ajax(options)
			.done((response: T) => resolve(response))
			.fail((jqXHR, textStatus, errorThrown) => {
				console.error("AJAX request failed: ", jqXHR, textStatus, errorThrown);
				reject(new Error(`AJAX request failed: ${textStatus}`));
			});
	});
}
